import { render, staticRenderFns } from "./ProjectAssignments.vue?vue&type=template&id=cd53cb0a"
import script from "./ProjectAssignments.vue?vue&type=script&lang=js"
export * from "./ProjectAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports